'use client';

import {I18NProvider, LocaleMessages} from '@epic-mw/i18n';

import {locales, defaultLocale} from '@i18n/config';

interface Props {
	locale: string;
	children?: React.ReactNode;
	messages?: LocaleMessages;
}

export const Localization = ({locale, children, messages}: Props) => {
	return (
		<I18NProvider
			locale={locale}
			locales={locales}
			messages={messages}
			defaultLocale={defaultLocale}>
			{children}
		</I18NProvider>
	);
};
